import React, { useState, useCallback } from "react";
import ConfirmModal from "../components/ui/ConfirmModal";
import {
  ConfirmModalContext,
  type ConfirmModalOptions,
} from "../context/ConfirmModalContext";

export function ConfirmModalProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [options, setOptions] = useState<ConfirmModalOptions | null>(null);

  const confirm = useCallback((opts: ConfirmModalOptions) => {
    setOptions(opts);
  }, []);

  const handleOk = () => {
    options?.onOk();
    setOptions(null);
  };

  const handleCancel = () => setOptions(null);

  return (
    <ConfirmModalContext.Provider value={{ confirm }}>
      {children}
      <ConfirmModal
        title="Confirm"
        open={!!options}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Yes"
        cancelText="Cancel"
        centered
      >
        <p>{options?.question}</p>
      </ConfirmModal>
    </ConfirmModalContext.Provider>
  );
}
